export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UsageSummary.vue?vue&type=template&id=2098f7e6&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/UsageSummary.vue?vue&type=template&id=2098f7e6&scoped=true&
// module id = 980
// module chunks = 0